import home from './home' // 首页


export default {
    home
}
